<template>
    <div>
        <h2 v-if="type === 'search'">MOAs / PAs</h2>
        <div>
            <h3>MOAs</h3>
            <div v-if="type === 'search'" class="container">
                <form @submit.prevent="loadMoaData" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2">
                            <label for="searchName">Search MOA Name</label>
                        </div>
                        <div class="col-md-4">
                            <input class="form-control" type="text" name="searchName" v-model="moaSearchDto.moaName">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <label for="searchDbNumber">Search DB Number</label>
                        </div>
                        <div class="col-md-4">
                            <input class="form-control" type="text" name="searchDbNumber" v-model="moaSearchDto.dbnumber">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <button class="btn btn-primary" type="submit" name="button" v-on:click="loadMoaData">Search</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="wrapper" style="margin-bottom: 50px;">
                <div  class="row row-wider">
                    <div class="col-md-12">
                        <loader v-if="loadingMoa" />
                        <div v-if="type === 'search'" class="pull-right">
                            <router-link to="/Moa" tag="button" class="btn btn-primary btn-block">Add New MOA</router-link>
                        </div>
                        <div>
                            <v-client-table :data="moaGridSpec.tableData" :columns="moaGridSpec.columns" :options="moaGridSpec.options">
                                <template slot="edit" slot-scope="props">
                                    <div style="text-align: center;">
                                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editMoaRow(props.row.moaId)"></a> -->
                                        <router-link :to="{ path: '/Moa/' + props.row.moaId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <h3>PAs</h3>
            <div v-if="type === 'search'" class="container">
                <form @submit.prevent="loadPaData" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2">
                            <label for="searchPaName">Search PA Name</label>
                        </div>
                        <div class="col-md-4">
                            <input class="form-control" type="text" name="searchPaName" v-model="paSearchDto.paName">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <label for="searchPaDbNumber">Search DB Number</label>
                        </div>
                        <div class="col-md-4">
                            <input class="form-control" type="text" name="searchPaDbNumber" v-model="paSearchDto.dbnumber">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <button class="btn btn-primary" type="submit" name="button" v-on:click="loadPaData">Search</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="wrapper">
                <div  class="row row-wider">
                    <div class="col-md-12">
                        <loader v-if="loadingPa" />
                        <div v-if="type === 'search'" class="pull-right">
                            <router-link to="/Pa" tag="button" class="btn btn-primary btn-block">Add New PA</router-link>
                        </div>
                        <div>
                            <v-client-table :data="paGridSpec.tableData" :columns="paGridSpec.columns" :options="paGridSpec.options">
                                <template slot="edit" slot-scope="props">
                                    <div style="text-align: center;">
                                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editPaRow(props.row.paId)"></a> -->
                                        <router-link :to="{ path: '/Pa/' + props.row.paId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import loggingService from '../services/util/loggingService'
  import moaService from '../services/moaService'
  import paService from '../services/paService'

  import loader from '../components/Loader.vue'

  export default {
      components: {
          loader
      },
      data: function () {
          return {
              isDebug: false,
              loadingMoa: true,
              loadingPa: true,
              moaSearchDto: {
                  moaName: '',
                  dbnumber: ''
              },
              paSearchDto: {
                  paName: '',
                  dbnumber: ''
              },
              moaGridSpec: {
                  columns: ['edit', 'workflowStatusDescription', 'workflowStatusDate', 'moaName', 'dbnumber', 'effectiveDate', 'createdDate'],
                  tableData: [],
                  options: {
                      dateFormat: 'YYYY-MM-DD',
                      perPage: 10,
                      perPageValues: [10, 25, 50, 100],
                      dateColumns: ['effectiveDate', 'createdDate', 'workflowStatusDate'],
                      headings: {
                          moaName: 'Name',
                          workflowStatusDescription: 'Status',
                          workflowStatusDate: 'Status Date',
                          dbnumber: 'DB Number',
                          effectiveDate: 'Effective Date',
                          createdDate: 'Created Date'
                      },
                      orderBy: {
                          ascending: false,
                          column: 'workflowStatusDate'
                      }
                  }
              },
              paGridSpec: {
                  columns: ['edit', 'workflowStatusDescription', 'workflowStatusDate', 'paName', 'dbnumber', 'effectiveDate', 'createdDate'],
                  tableData: [],
                  options: {
                      dateFormat: 'YYYY-MM-DD',
                      perPage: 10,
                      perPageValues: [10, 25, 50, 100],
                      dateColumns: ['effectiveDate', 'createdDate', 'workflowStatusDate'],
                      headings: {
                          paName: 'Name',
                          workflowStatusDescription: 'Status',
                          workflowStatusDate: 'Statue Date',
                          dbnumber: 'DB Number',
                          effectiveDate: 'Effective Date',
                          createdDate: 'Created Date'
                      },
                      orderBy: {
                          ascending: false,
                          column: 'workflowStatusDate'
                      }
                  }
              }
          }
      },
      props: {
          type: {
              type: String,
              default: 'search'
          }
      },
      mounted () {
          loggingService.log(this.isDebug, 'MOAs & PAs', 'mounted')
          Promise.all([this.loadMoaData(), this.loadPaData()]).then(response => {
          })
      },
      methods: {
          loadMoaData () {
              if (this.type === 'search') {
                  loggingService.log(this.isDebug, 'MOAs & PAs', 'search - loadMoaData')
                  moaService.search(this.$http, this.moaSearchDto).then(response => {
                      loggingService.log(this.isDebug, 'MOAs', 'moaService.search.then')
                      this.moaGridSpec.tableData = response.data
                      this.loadingMoa = false
                      return response
                  })
              } else if (this.type === 'todo') {
                  loggingService.log(this.isDebug, 'MOAs & PAs', 'todo - loadMoaData')
                  moaService.todo(this.$http, this.moaSearchDto).then(response => {
                      loggingService.log(this.isDebug, 'MOAs', 'moaService.todo.then')
                      this.moaGridSpec.tableData = response.data
                      this.loadingMoa = false
                      return response
                  })
              } else {
                  loggingService.log(this.isDebug, 'MOAs', 'loadMoaData - unknown type: ' + this.type)
              }
          },
          loadPaData () {
              if (this.type === 'search') {
                  loggingService.log(this.isDebug, 'MOAs & PAs', 'search - loadPaData')
                  paService.search(this.$http, this.paSearchDto).then(response => {
                      loggingService.log(this.isDebug, 'PAs', 'paService.search.then')
                      this.paGridSpec.tableData = response.data
                      this.loadingPa = false
                      return response
                  })
              } else if (this.type === 'todo') {
                  loggingService.log(this.isDebug, 'MOAs & PAs', 'todo - loadPaData')
                  paService.todo(this.$http, this.paSearchDto).then(response => {
                      loggingService.log(this.isDebug, 'PAs', 'paService.todo.then')
                      this.paGridSpec.tableData = response.data
                      this.loadingPa = false
                      return response
                  })
              } else {
                  loggingService.log(this.isDebug, 'PAs', 'loadPaData - unknown type: ' + this.type)
              }
          },
          editMoaRow (id) {
              loggingService.log(this.isDebug, 'MOA', 'editMoaRow, id: ' + id)

              this.$router.push('/Moa/' + id)
          },
          editPaRow (id) {
              loggingService.log(this.isDebug, 'PA', 'editPaRow, id: ' + id)

              this.$router.push('/Pa/' + id)
          }
      }
  }
</script>



// WEBPACK FOOTER //
// MoasPas.vue?7d5a65a6